import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "../../../layout";
import { CircularProgress } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { select_content_getContentHtml_api } from "../../../redux/content/getContentHtml/getContentHtml";
import { notificationAlertErrorApi } from "../../method/notificationAlertErrorApi/notificationAlertErrorApi";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "60vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px 10px",
    borderTop: "1px solid rgba(0,0,0,0.1)",
    borderBottom: "1px solid rgba(0,0,0,0.1)",
  },
  gridLoading: {
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    marginRight: 5,
  },
}));

export default function Index({ match }) {
  const classes = useStyles();
  let dispatch = useDispatch();
  const history = useHistory();

  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(null);

  const location = useLocation(); // آدرس جاری
  const requestParam = location.pathname.replace(
    "/Content/GetContentHtml/",
    "",
  );

  const apiGetCOntentHtml = () => {
    let payload = {
      data: {
        param: requestParam,
      },
      headers: {},
    };

    setLoading(true);

    select_content_getContentHtml_api(payload)
      .then((res) => {
        let data = res?.data?.data;
        if (data) {
          try {
            var test1 = document.createElement("textarea");
            test1.innerHTML = data;
            // setContent(test1?.value);
            setContent(res?.data?.data);
          } catch (error) {
            console.error("خطا در پردازش داده:", error);
          }
          // var test1 = document.createElement('textarea')
          // test1.innerHTML = data
          // // setContent(test1?.value);
          // setContent(res?.data?.data);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 404) {
          history.push("/404");
          return;
        }
        notificationAlertErrorApi(error, dispatch);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    apiGetCOntentHtml();
  }, [requestParam]);

  if (loading) {
    return (
      <div className={classes["gridLoading"]}>
        <div className={classes["card"]}>
          <CircularProgress size={24} />
          <p className={classes["title"]}>در حال بارگذاری...</p>
        </div>
      </div>
    );
  }

  return (
    <Layout disableHeader={true}>
      <div className={classes["root"]}>
        {content ? (
          <div
            className={classes.content}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <p>محتوایی برای نمایش وجود ندارد.</p>
        )}
      </div>
    </Layout>
  );
}
